import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { message } from "antd";
import Instance from "../../AxiosConfig";

const EditVendorModal = ({ show, handleClose, agentData,fetchData }) => {
  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");

  // ✅ Prefill fields when agentData changes
  useEffect(() => {
    if (agentData) {
      setName(agentData.agentName || "");
      setEmail(agentData.agentEmail || "");
      setMobileNumber(agentData.agentNumber || "");
    }
  }, [agentData]);

  // ✅ Clear fields when modal closes
  useEffect(() => {
    if (!show) {
      setName("");
      setEmail("");
      setMobileNumber("");
    }
  }, [show]);

  // ✅ Save / Update agent details
  const handleSave = async () => {
    try {
      // const token = localStorage.getItem("token");
      const response = await Instance.put(
        `agents/${agentData._id}`,
        {
          agentName: name,
          agentEmail: email,
          agentNumber: mobileNumber,
        },
        
      );

      if (response.status === 200) {
        message.success({
          content: "Agent details updated successfully!",
          duration: 3,
          className: "custom-agent-toast-wrapper",
        });
        handleClose();
        fetchData(); // Refresh the agents list
      }
    } catch (error) {
      console.error(error);
      message.error("Failed to update agent details.");
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      backdrop="static"
      dialogClassName="custom-agent-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Vendor</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mb-3">
                <label className="form-label">Vendor Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Vendor name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Mobile Number</label>
                <input
                  type="tel"
                  className="form-control"
                  placeholder="Enter mobile number"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                />
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-2">
              <button
                type="button"
                className="agents-discard-button"
                onClick={handleClose}
              >
                Discard Changes
              </button>

              <button
                type="button"
                className="agents-save-button"
                onClick={handleSave}
              >
                Save Changes
              </button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default EditVendorModal;
